<template>
  <footer class="footer" :style="{backgroundColor: ($route.path=='/specialFundDetails' || $route.path=='/specialFundNewsDetails')?themeColor:'#B8210F',width: screenWidth>1000?'':'100%'}">
    <div class="footer-links">
      <a @click="toHerf('/organizationalProfile/foundationIntroduction')" class="footer-text footer-font-hover">{{ $t('OrganizationalProfile') }}</a> |
      <a @click="toHerf('/foundationProject')" class="footer-text footer-font-hover">{{ $t('FoundationProject') }}</a> |
      <a @click="toHerf('/specialFund')" class="footer-text footer-font-hover">{{ $t('SpecialFund') }}</a> |
      <a @click="toHerf('/contactUs')" class="footer-text footer-font-hover">{{ $t('ContactUs') }}</a>
    </div>

    <div class="social-icons">
      <el-row :gutter="10" :style="{width: screenWidth>540?'80%':'63%',}">
        <el-col :span="screenWidth>540?6:12">
          <el-popover placement="top" popper-class="el-popover-self" trigger="hover">
            <div style="max-width: 13rem;">
              <img src="../../assets/img/companyWechat.jpg" alt="" width="100%">
            </div>
            <img slot="reference" src="@/assets/img/footer/weixin.png" />
          </el-popover>
          <p class="footer-font-hover">{{ $t('FollowWeChatAccount') }}</p>
        </el-col>
        <el-col :span="screenWidth>540?6:12">
          <el-popover placement="top" popper-class="el-popover-self" trigger="hover">
            <div style="max-width: 13rem;">
              <img src="../../assets/img/companyWeibo.jpg" alt="" width="100%">
            </div>
            <img slot="reference" src="@/assets/img/footer/weibo.png" />
          </el-popover>
          <p class="footer-font-hover">{{ $t('FollowWeiboAccount') }}</p>
        </el-col>
        <el-col :span="screenWidth>540?6:12">
          <img src="@/assets/img/footer/email.png" />
          <p class="footer-font-hover">Email: info@jasfoundation.org</p>
        </el-col>
        <el-col :span="screenWidth>540?6:12">
          <img src="@/assets/img/footer/tel.png" />
          <p class="footer-font-hover">Phone: +86.010.6585.2888</p>
        </el-col>

      </el-row>
      <!-- <div class="social-icons-div">
        <el-popover placement="top" popper-class="el-popover-self" trigger="hover">
          <div style="max-width: 13rem;">
            <img src="../../assets/img/companyWechat.jpg" alt="" width="100%">
          </div>
          <img slot="reference" src="@/assets/img/footer/weixin.png" />
        </el-popover>
        <p class="footer-font-hover">{{ $t('FollowWeChatAccount') }}</p>
      </div>
      <div class="social-icons-div">
        <el-popover placement="top" popper-class="el-popover-self" trigger="hover">
          <div style="max-width: 13rem;">
            <img src="../../assets/img/companyWeibo.jpg" alt="" width="100%">
          </div>
          <img slot="reference" src="@/assets/img/footer/weibo.png" />
        </el-popover>
        <p class="footer-font-hover">{{ $t('FollowWeiboAccount') }}</p>
      </div>
      <div class="social-icons-div">
        <img src="@/assets/img/footer/email.png" />
        <p class="footer-font-hover">Email: info@jastoundation.org</p>
      </div>
      <div class="social-icons-div">
        <img src="@/assets/img/footer/tel.png" />
        <p class="footer-font-hover">Phone: +86.010.6585.2888</p>
      </div> -->
    </div>
    <div class="contact-info" :style="{'font-size': screenWidth>540?'0.8rem':'0.6rem',}" v-if="isMobile=='pc'">
      <div style="display: flex;align-items: center;justify-content: center;padding: 10px 0;">
        <div style="display: flex;align-items: center;justify-content: center;">
          <img src="../../assets/img/beian.png" style="width: 15px;height: 15px;"/>
          <a style="color: #fff;margin: 0 6px;text-decoration: unset;" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010102007476" rel="noreferrer" target="_blank">京公网安备11010102007476号</a>
        </div>
        <p>
          Copyright © 2012 Samaranch Foundation. All rights reserved.
          <span style="margin-left: 1rem">京ICP备14030541号-1</span>
        </p>
      </div>
      
    </div>

    <div class="contact-info" :style="{'font-size': screenWidth>540?'0.8rem':'0.6rem',}" v-if="isMobile=='mobile'">
      <div style="display: flex;align-items: center;justify-content: center;padding: 10px 0;flex-direction: column;">
        <div style="display: flex;align-items: center;justify-content: center;">
          <img src="../../assets/img/beian.png" style="width: 15px;height: 15px;"/>
          <a style="color: #fff;margin: 0 6px;text-decoration: unset;" href="https://beian.mps.gov.cn/#/query/webSearch?code=11010102007476" rel="noreferrer" target="_blank">京公网安备11010102007476号</a>
        </div>
        <p>
          <span>Copyright © 2012 Samaranch Foundation. All rights reserved.</span>  
          <span style="margin-left: 1rem">京ICP备14030541号-1</span>
        </p>
      </div>
      
    </div>
    
      
    
  </footer>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['themeColor', 'screenWidth']),
    isMobile() {
        const userAgentInfo = navigator.userAgent;
        const agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        for (let i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > -1) {
                return 'mobile'; // 移动端
            }
        }
        return 'pc'; // PC端
    }
  },
  name: 'Footer',
  data() {
    return {
      visible: true,
    }
  },
  methods: {
    toHerf(url) {
      this.$router.push(url)
    },
  },
};
</script>

<style lang="less" scoped>
footer {
  // background-color: #B8210F; /* 红色背景 */
  color: white;
  padding-top: 20px;
  text-align: center;
  // width: 100%;
  width: 1000px;
  font-size: 1rem;
}

.footer-links {
  margin-bottom: 20px;
}

.footer-links a {
  color: white;
  margin: 0 15px;
  text-decoration: none;
}

.social-icons {
  display: flex;
  justify-content: center;
  font-size: 0.8rem;
}

.social-icons img {
  width: 15%;
}
.social-icons-div {
  width: 40%;
  margin: 0 1%;
  text-align: center;
  word-break: break-all;
}
.social-icons-div {
  width: 40%;
  margin: 0 1%;
  text-align: center;
  word-break: break-all;
}
.contact-info {
  /* margin-bottom: 20px; */
  background-color: #222;
  color: white;
  padding: 10px 0;
  width: 100%;
  text-align: center;
  font-size: 0.8rem;
  margin-top: 20px;
}
.footer-text {
  font-size: 0.9rem;
}
</style>
<style lang="less">
.el-popover-self {
  max-width: 13rem !important;
  min-width: 5rem !important;
  width: 20% !important;
  padding: 0;
}
.footer-font-hover:hover {
  font-size: 1rem;
}
</style>